import React, { useState, useEffect } from "react";
import { Box, useTheme, useMediaQuery, IconButton } from "@mui/material";
import GradientButton from "../gradient-button";
import ImageOverlayButton from "./image-overlay-button";
import useWindowWidth from "../../../hooks/window-size/use-window-width";
import HeroSectionMedium from "./hero-medium-section";
export const HeroSection = ({ slides, autoPlayInterval = 5000 }) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, autoPlayInterval);

    return () => clearInterval(timer);
  }, [slides.length, autoPlayInterval, currentSlide]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prevSlide) => (prevSlide - 1 + slides.length) % slides.length
    );
  };
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 1200;
  const isSmallMobile = windowWidth < 768;
  let height = 450;

  // Adjust height based on window width
  if (windowWidth >= 900 && windowWidth < 1900) {
    // Decrease height from 450 to a minimum value as width goes from 1400px to 1280px
    height = 450 - (1900 - windowWidth) * 0.2; // You can adjust the factor (0.1) to control the height decrease rate
  } else {
    height = 450 - (1800 - windowWidth) * 0.2;
  }
  return (
    <Box
      sx={{
        position: "relative",
        height: isMobile ? (isSmallMobile ? "200px" : "350px") : height,
        overflow: "hidden",
        mt: 1.4,
      }}
    >
      {isMediumScreen ? (
        <HeroSectionMedium slide={slides[currentSlide]} />
      ) : (
        slides.map((slide, index) => (
          <Box
            onClick={slide.onButtonClick}
            key={slide.id}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              borderRadius: "12px",
              height: "100%",
              opacity: index === currentSlide ? 1 : 0,
              transition: "opacity 0.5s ease-in-out",
              backgroundImage: `url(${slide.backgroundImage})`,
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              pointerEvents: index === currentSlide ? "auto" : "none",
            }}
          >
            {/* <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
              }}
            />
            <Box
              sx={{ position: "absolute", top: 0, right: 0, height: "100%" }}
            >
              <img
                src={slide.athleteImage}
                alt="Athlete"
                style={{ height: "100%" }}
              />
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: "10%",
                left: "3.2%",
                maxWidth: "50%",
              }}
            >
              <ImageOverlayButton
                text={slide.specialEvent}
                fontSize={fontSizes.info}
                textColor={darkColors.buttonTop}
                width={windowWidth < 1300 ? "50%" : 160} // Optional: Adjust width if needed
              />
              <Typography
                // fontSize={fontSizes.superHeading1}
                fontSize={`clamp(12px, 2.4vw,${fontSizes.superHeading1})`}
                lineHeight={1.2}
                textAlign="left"
                color="white"
                sx={{ fontFamily: "MontserratBold", mb: 2 }}
              >
                {slide.title}
              </Typography>
              <Typography
                fontSize={`clamp(8px, 0.9vw,18px)`}
                textAlign="left"
                width="65%"
                sx={{ mb: 3 }}
                color={darkColors.betOnRaces}
              >
                {slide.description}
              </Typography>
              <Box display="flex" justifyContent="left">
                <GradientButton
                  text={slide.buttonText}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event bubbling
                    slide.onButtonClick(); // Call the specific slide's onClick handler
                  }}
                  py={windowWidth < 1300 ? 0.5 : 1.45}
                  // width={windowWidth < 1000 ? "60%" : "auto"}
                  variant="contained"
                />
              </Box>
            </Box> */}
          </Box>
        ))
      )}
      {/* <IconButton
        onClick={prevSlide}
        sx={{
          position: "absolute",
          left: 10,
          top: "50%",
          transform: "translateY(-50%)",
          color: "white",
        }}
        aria-label="Previous slide"
      >
        <ChevronLeftOutlinedIcon />
      </IconButton>
      <IconButton
        onClick={nextSlide}
        sx={{
          position: "absolute",
          right: 10,
          top: "50%",
          transform: "translateY(-50%)",
          color: "white",
        }}
        aria-label="Next slide"
      >
        <ChevronRightOutlinedIcon />
      </IconButton> */}
      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        {slides.map((_, index) => (
          <Box
            key={index}
            component="button"
            onClick={() => goToSlide(index)}
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor:
                index === currentSlide ? "white" : "rgba(255,255,255,0.5)",
              border: "none",
              margin: "0 5px",
              padding: 0,
              cursor: "pointer",
            }}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </Box>
    </Box>
  );
};
